import { useCallback } from 'react';
import { useCustomMindmap, getRectOfNodes, getTransformForBounds } from 'Custom-Mindmap';
import { toPng } from 'html-to-image';

const IMAGE_WIDTH = 1024;
const IMAGE_HEIGHT = 768;
const MIN_ZOOM = 0.5;
const MAX_ZOOM = 2;
const IMAGE_BACKGROUND = '#1a365d';
const FILE_NAME = 'MindMap.png';

const saveDataUrl = (dataUrl) => {
    const link = document.createElement('a');
    link.setAttribute('download', FILE_NAME);
    link.setAttribute('href', dataUrl);
    link.click();
};

/** Returns a function that saves the whole map, fitted into one PNG. */
export const useDownloadImage = () => {
    const { getNodes } = useCustomMindmap();

    return useCallback(() => {
        const [x, y, zoom] = getTransformForBounds(getRectOfNodes(getNodes()), IMAGE_WIDTH, IMAGE_HEIGHT, MIN_ZOOM, MAX_ZOOM);

        return toPng(document.querySelector('.cm-viewport'), {
            backgroundColor: IMAGE_BACKGROUND,
            width: IMAGE_WIDTH,
            height: IMAGE_HEIGHT,
            style: {
                width: IMAGE_WIDTH,
                height: IMAGE_HEIGHT,
                transform: `translate(${x}px, ${y}px) scale(${zoom})`,
            },
        }).then(saveDataUrl);
    }, [getNodes]);
};
